(ns quuppa.qsm.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub ::is-qsm-owner?
            (fn [db]
              (:is-qsm-owner? db)))

(rf/reg-sub
  ::session
  (fn [db [_]]
    (:session db)))

(rf/reg-sub
  ::user
  :<- [::session]
  (fn [session [_]]
    (:user session)))

(rf/reg-sub
  ::privileges
  :<- [::session]
  (fn [session _]
    (-> session :user :privileges set)))

(rf/reg-sub ::has-privilege
         :<- [::privileges]
         (fn [privileges [_ privilege]]
           (contains? privileges privilege)))
